import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../Services/storage.service';

@Component({
  selector: 'app-congres-virtuel-comites',
  templateUrl: './congres-virtuel-comites.component.html',
  styleUrls: ['./congres-virtuel-comites.component.scss']
})
export class CongresVirtuelComitesComponent implements OnInit {

  loginBoxShow = {display:false};

  con_user = null;

  constructor(private router:Router, private storagedata:StorageService) {
    this.con_user = storagedata.getCongresConUser();
   }

  ngOnInit() {
  }

  showLoginBox(){
    this.con_user ? this.router.navigateByUrl('/congres-virtuel/welcome') : this.loginBoxShow.display = true;
  }

  goToRegisterPage(){
    this.con_user ? alert('Vous êtes déjà connecté!') : this.router.navigateByUrl('/congres-virtuel/auth');
  }

}
